import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PredesComplianceMessageMappingErrorsReport
  from '../../components/PredesComplianceMessageMappingErrorsReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesComplianceMessageMappingErrorsErrorMessagesSelectors';

export function PredesComplianceMessageMappingErrorsErrorMessagesContainer(props) {
  return (
    <PredesComplianceMessageMappingErrorsReport
      reportId={ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesComplianceMessageMappingErrorsErrorMessagesContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesComplianceMessageMappingErrorsErrorMessagesContainer);
